import { useToast } from '@solfacil/girassol';
export default defineNuxtRouteMiddleware((to) => {
  const { createErrorToast } = useToast();
  // check if to router is /pedido and check id has id in path, if not redirect to /pedidos

  if (to.name === 'pedidos-id' && to.params.id) {
    // check if id is a number
    if ((to.params.id === 'null' || to.params.id === 'undefined')) {
      createErrorToast({
        title: 'Oops...',
        description:
          'Tivemos um problema ao tentar buscar o pedido solicitado.'
      });
      return navigateTo('/pedidos');
    }
  }
});
